<!--
Use ngx-loading-bar/http-client when load this page.
-->
<ngx-loading-bar [color]="'white'"></ngx-loading-bar>
<!-- / -->

<ng-container *ngIf="kit?.id; else loading">
  <main class="w-full px-4">
    <div class="mx-auto max-w-7xl">
      <section>
        <div class="hidden sm:block">
          <img src="/assets/images/subscription/banner-header.png" />
        </div>
      </section>

      <!-- Breadcrumbs -->
      <nav class="flex mt-12" aria-label="Breadcrumb">
        <ol role="list" class="flex items-center space-x-4">
          <li>
            <div>
              <a [routerLink]="['/']" class="text-gray-400 hover:text-pink-800">
                <svg class="h-5 w-5 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M9.293 2.293a1 1 0 011.414 0l7 7A1 1 0 0117 11h-1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3a1 1 0 00-1-1H9a1 1 0 00-1 1v3a1 1 0 01-1 1H5a1 1 0 01-1-1v-6H3a1 1 0 01-.707-1.707l7-7z" clip-rule="evenodd" />
                </svg>
                <span class="sr-only">Início</span>
              </a>
            </div>
          </li>

          <li>
            <div class="flex items-center">
              <svg class="h-5 w-5 flex-shrink-0 text-pink-800" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
              </svg>
              <a [routerLink]="['/subscription']" class="ml-4 text-sm font-medium text-gray-500 hover:text-pink-800" aria-current="page">Clube Gê</a>
            </div>
          </li>

          <li>
            <div class="flex items-center">
              <svg class="h-5 w-5 flex-shrink-0 text-pink-800" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
              </svg>
              <a class="ml-4 text-sm font-medium text-gray-500 hover:text-pink-800" aria-current="page">{{kit.name}}</a>
            </div>
          </li>
        </ol>
      </nav>

      <main class="mx-auto py-20 sm:px-6 lg:max-w-7xl">
        <!-- Product -->
        <div class="lg:grid lg:grid-cols-7 lg:grid-rows-1 lg:gap-x-8 lg:gap-y-10 xl:gap-x-16">
          <!-- Product image -->
          <div class="lg:col-span-4 lg:row-end-1">
            <div class="aspect-h-1 aspect-w-2 overflow-hidden rounded-lg">
              <img src="{{kit.img_spotlight_banner}}" alt="{{kit.name}}" class="object-contain object-center" />
            </div>
          </div>

          <!-- Product details -->
          <div class="mx-auto mt-14 max-w-2xl sm:mt-16 lg:col-span-3 lg:row-span-2 lg:row-end-2 lg:mt-0 lg:max-w-none">
            <div class="flex flex-col-reverse">
              <div class="mt-4 space-y-2">
                <h1 class="text-2xl font-bold tracking-tight text-pink-800 sm:text-3xl">{{kit.name}}</h1>
                <p class="font-semibold text-gray-700 text-lg">R${{kit.price | number:'1.2-2':'pt-BR'}}</p>
                <ng-container *ngIf="kit.check_if_delivery_can_be_free">
                  <div class="bg-green-100 text-green-800 p-2 rounded-md text-sm uppercase font-semibold">
                    <p>Aproveite Frete Grátis</p>
                  </div>
                </ng-container>

                <ng-container *ngIf="!kit.check_if_delivery_can_be_free">
                  <p class="font-semibold text-gray-700">Frete: R${{kit.subscription.delivery_price | number:'1.2-2':'pt-BR'}}</p>
                </ng-container>
              </div>
            </div>

            <p class="mt-6 text-gray-500">{{kit.description}}</p>

            <div class="mt-10 grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2">
              <button (click)="collectiveMarketplaceCartSubscriptionKitServiceCreate()" type="button" class="flex w-full items-center justify-center rounded-md border border-transparent bg-pink-800 px-4 py-3 font-medium text-white text-sm hover:bg-pink-900 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:ring-offset-2 focus:ring-offset-gray-50">
                Agendar Entrega
              </button>
            </div>
          </div>

          <div class="mx-auto mt-4 w-full max-w-2xl lg:col-span-4 lg:mt-0 lg:max-w-none">
            <div>
              <h3 class="text-sm font-medium text-gray-900">Vantagens</h3>
              <div class="prose prose-sm mt-4 text-gray-500">
                Economize
                <span *ngIf="kit.subscription.price_discount_type == 'fixed'"><strong>R$ {{kit.subscription.price_discount | number:'1.2-2':'pt-BR'}}</strong></span>
                <span *ngIf="kit.subscription.price_discount_type == 'percent'"><strong>{{kit.subscription.price_discount | number:'1.2-2':'pt-BR'}}%</strong></span>
                em suas compras, planejando uma assinatura de entrega recorrente do seu pedido.
                <ng-container *ngIf="kit.subscription.available_if == 'city'">
                  <p>Frete Grátis para <strong>{{kit.subscription.available_if_content_value}}</strong>. <span *ngIf="kit.subscription.delivery_free_min_buy_price > 0">Nas compras acima de R$ {{kit.subscription.delivery_free_min_buy_price | number:'1.2-2':'pt-BR'}}.</span></p>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <ng-container *ngIf="kit.products.length > 0">
          <div class="mx-auto mt-10 w-full max-w-2xl lg:col-span-4 lg:mt-10 lg:max-w-none">
            <div>
              <div class="border-b border-gray-200 pb-2">
                <div class="-mb-px flex space-x-8" aria-orientation="horizontal">
                  <button class="text-sm font-medium text-gray-900" aria-controls="tab-panel-reviews" role="tab" type="button">Conteúdo</button>
                </div>
              </div>
              <div>
                <h3 class="sr-only">Produtos que compõem o Kit</h3>

                <div>
                  <div class="mt-2 flow-root">
                    <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8 no-scrollbar">
                      <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                        <table class="min-w-full divide-y divide-gray-300">
                          <thead>
                            <tr>
                              <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-3">Produto</th>
                              <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Preço Comum</th>
                              <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Preço com Recorrência</th>
                              <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Quantidade</th>
                              <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Economia</th>
                            </tr>
                          </thead>
                          <tbody class="bg-white">
                            <!-- Odd row -->
                            <ng-container *ngFor="let kitProduct of kit.products">
                              <tr>
                                <td [routerLink]="['/p/'+kitProduct.product.url_handle+'/id/'+kitProduct.product.id]" class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-3 un cursor-pointer">{{kitProduct.product.name}}</td>
                                <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center">R${{kitProduct.price_without_discount | number:'1.2-2':'pt-BR'}}</td>
                                <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center">R${{kitProduct.price | number:'1.2-2':'pt-BR'}}</td>
                                <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center">{{kitProduct.kit_rel_product_inventory_quantity}}</td>
                                <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center">{{kit.price_discount_percent | number:'1.2-2':'pt-BR'}}%</td>
                              </tr>
                            </ng-container>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </main>
    </div>
  </main>
</ng-container>

<ng-template #loading>
  <div class="mx-auto py-20 sm:px-6 lg:max-w-7xl">
    <nav aria-label="Breadcrumb">
      <ol role="list" class="flex items-center space-x-4 mb-6">
        <li>
          <div role="status" class="max-w-sm animate-pulse">
            <div class="bg-gray-200 rounded w-48 h-3 mb-4"></div>
          </div>
        </li>
      </ol>
    </nav>

    <!-- Product -->
    <div class="lg:grid lg:grid-cols-2 lg:grid-rows-1 lg:gap-x-8 lg:gap-y-10 xl:gap-x-16">
      <!-- Image gallery -->

      <div class="w-full">
        <!-- Tab panel, show/hide based on tab state. -->

        <div role="status" class="space-y-8 animate-pulse md:space-y-0 md:space-x-8 md:flex md:items-center">
          <div class="flex items-center justify-center w-full h-48 bg-gray-300 rounded sm:w-full sm:h-96"></div>
        </div>
      </div>

      <!-- Product info -->
      <div class="mt-10 sm:mt-16 sm:px-0 lg:mt-0 flex flex-col space-y-4">
        <div>
          <div role="status" class="space-y-8 animate-pulse md:space-y-0 md:space-x-8 md:flex md:items-center">
            <div class="flex items-center justify-center w-full h-8 bg-gray-300 rounded"></div>
          </div>
        </div>

        <div role="status" class="space-y-8 animate-pulse md:space-y-0 md:space-x-8 md:flex md:items-center">
          <div class="flex items-center justify-center w-full h-44 bg-gray-300 rounded"></div>
        </div>

        <div role="status" class="space-y-8 animate-pulse md:space-y-0 md:space-x-8 md:flex md:items-center">
          <div class="flex items-center justify-center w-full h-36 bg-gray-300 rounded"></div>
        </div>
      </div>
    </div>

    <div role="status" class="space-y-8 animate-pulse md:space-y-0 md:space-x-8 md:flex md:items-center mt-10">
      <div class="flex items-center justify-center w-full h-48 bg-gray-300 rounded sm:w-full sm:h-96"></div>
    </div>
  </div>
</ng-template>
